import Vue from "vue";
//高德离线地图
import VueAMap from "@vuemap/vue-amap";
import "@vuemap/vue-amap/dist/style.css";
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: "f62ad1480488b157170ec54b154bf478",
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.ToolBar",
    "AMap.OverView",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor",
    "AMap.CircleEditor",
    "AMap.zoom",
    "AMap.Geolocation",
    "AMap.Geocoder",
    "AMap.Polyline",
    "AMap.MouseTool",
    "AMap.PolylineEditor",
    "AMap.DistrictSearch"
  ]
  // v: "1.4.4"
});



// WEBPACK FOOTER //
// ./src/plugin/aMap.js